import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { UserPlus } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { authenticatedFetch } from '../../lib/api/client';
import { config } from '../../lib/config';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { TemporaryPasswordDialog } from './TemporaryPasswordDialog';
export function InviteToPortalDialog({ employeeId, employeeName, currentEmail, trigger, }) {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState(currentEmail || '');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPasswordDialog, setShowPasswordDialog] = useState(false);
    const [passwordData, setPasswordData] = useState(null);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await authenticatedFetch(config.api.people, `/employees/${employeeId}/portal-access`, {
                method: 'POST',
                body: JSON.stringify({
                    email: email || undefined,
                    mode: 'email_invite',
                }),
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error?.message || 'Failed to enable portal access');
            }
            const result = await response.json();
            // Show temporary password dialog
            if (result.temporaryPassword) {
                setPasswordData({
                    email: result.email,
                    temporaryPassword: result.temporaryPassword,
                });
                setShowPasswordDialog(true);
                setOpen(false);
            }
            else {
                toast.success('Portal access enabled successfully');
                setOpen(false);
                // Reload the page to show updated status
                window.location.reload();
            }
        }
        catch (error) {
            console.error('Error enabling portal access:', error);
            toast.error(error instanceof Error ? error.message : 'Failed to enable portal access');
        }
        finally {
            setIsSubmitting(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, { open: open, onOpenChange: setOpen, children: [_jsx(DialogTrigger, { asChild: true, onClick: () => setOpen(true), children: trigger || (_jsxs(Button, { variant: "outline", children: [_jsx(UserPlus, { className: "mr-2 h-4 w-4" }), "Invite to Portal"] })) }), _jsxs(DialogContent, { className: "sm:max-w-[500px]", children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: "Invite Employee to Portal" }), _jsxs(DialogDescription, { children: ["Enable portal access for ", employeeName, ". They will receive login credentials to access their employee dashboard."] })] }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsx("div", { className: "space-y-4 py-4", children: _jsxs("div", { children: [_jsxs(Label, { htmlFor: "email", children: ["Email Address ", !currentEmail && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(Input, { id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "employee@company.com", required: !currentEmail, className: "mt-1" }), _jsx("p", { className: "text-xs text-gray-500 mt-2", children: currentEmail
                                                        ? 'Leave empty to use the email on file, or enter a different one.'
                                                        : 'Email is required to invite this employee to the portal.' })] }) }), _jsxs(DialogFooter, { children: [_jsx(Button, { type: "button", variant: "outline", onClick: () => setOpen(false), children: "Cancel" }), _jsx(Button, { type: "submit", disabled: isSubmitting, children: isSubmitting ? 'Enabling Access...' : 'Enable Portal Access' })] })] })] })] }), passwordData && (_jsx(TemporaryPasswordDialog, { open: showPasswordDialog, onOpenChange: (open) => {
                    setShowPasswordDialog(open);
                    if (!open) {
                        // Reload to show updated portal access status
                        window.location.reload();
                    }
                }, email: passwordData.email, temporaryPassword: passwordData.temporaryPassword, employeeName: employeeName }))] }));
}
